<template>
    <div>
        <b-card>
            <b-row>
                <b-col md="2" class="mb-3">
                    <b-form-group  label="Orden" class="mb-0">
                        <b-input-group>
                        <b-form-select v-model="orden" slot="append" @input="listarRetenciones">
                            <option :value="'asc'">Más Antiguo</option>
                            <option :value="'desc'">Más Reciente</option>
                        </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="8">
                    <div class="col-md-12 text-center">
                        <b-button title="Actualizar" variant="secondary" @click="listarRetenciones">
                        <i class="fa fa-sync-alt"></i>
                        </b-button>
                    </div>
                </b-col>
                <b-col md="2">
                    <b-form-group  label="Mostrar" class="mb-0">
                        <b-input-group>
                        <b-form-select v-model="limite" slot="append" @input="listarRetenciones">
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                        </b-form-select>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <template v-if="cargando">
                    <div class="row">
                        <div class="col-md-12 text-center">
                            <h3>
                            Cargando
                            <i class="fa fa-spin fa-spinner"></i>
                            </h3>
                        </div>
                    </div>
            </template>
            <template v-else>
                <b-table 
                :outlined="outlined"
                small
                :items="retenciones"
                :fields="retenciones_fields">   
                <!-- <template slot="documento" slot-scope="row">
                    {{row.item.serie}}-{{row.item.numero}}
                </template>  -->
                <template slot="estado" slot-scope="row">
                    <template v-if="row.item.baja==1">
                        <template v-if="row.item.emitido==1 && row.item.baja==1">
                            <div>
                                <span class="badge badge-dark">
                                    Baja
                                    <i class="fa fa-ban"></i>
                                </span>
                            </div>
                        </template>
                        <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                            <div>
                                <span class="badge badge-info">
                                    Baja pendiente
                                    <i class="fa fa-ban"></i>
                                </span>
                            </div>
                        </template> 
                    </template>  
                    <div v-if="row.item.emitido==1 && row.item.baja==0">
                        <span class="badge badge-success">
                            Emitido
                            <i class="fa fa-check"></i>
                        </span>
                    </div>
                    <div v-else-if="row.item.emitido==0">
                        <span class="badge badge-warning">
                            Procesando
                            <i class="fa fa-spin fa-spinner"></i>
                        </span>
                    </div>
                    <div v-else-if="row.item.emitido==2">
                        <span class="badge badge-danger">
                            Rechazado
                            <i class="fa fa-times"></i>
                        </span>
                    </div>
                    <!-- <template v-else>
                        <template v-if="row.item.emitido==1 && row.item.baja==1">
                            <div>
                                <span class="badge badge-dark">
                                    Baja
                                    <i class="fa fa-ban"></i>
                                </span>
                            </div>
                        </template>
                        <template v-else-if="row.item.emitido==3 && row.item.baja==0">
                            <div>
                                <span class="badge badge-info">
                                    Baja pendiente
                                    <i class="fa fa-ban"></i>
                                </span>
                            </div>
                        </template> 
                    </template>     -->
                </template>
                <template slot="acciones" slot-scope="row">
                    <b-button-group>
                    <b-button size="sm" variant="ligth" title="Vista Previa" @click="viewPdfRetencion(row.item)"><i class="fa fa-tv text-dark"></i></b-button>
                    <template v-if="row.item.baja !==1">
                        <b-button size="sm" variant="danger" title="Baja" @click="abrirModalBaja(row.item)"><i title="Baja" class="fa fa-trash-alt text-white"></i></b-button>
                    </template>
                </b-button-group>    
                </template>                           
                </b-table>
                <!-- INICIO Modal BAJA -->
                <b-modal id="modal-baja" title="Baja del documento" v-model="mostrarModal">
                <template #modal-header>
                 <h5>Baja del documento {{dataSeleccionada ? dataSeleccionada.serie + '-' + dataSeleccionada.numero : ''}}</h5>
                </template>
                    
                <h5 class="text-center"> ¿Esta seguro que desea solicitar la baja del documento {{dataSeleccionada ? dataSeleccionada.serie + '-' + dataSeleccionada.numero : ''}}?</h5>
                <p class="text-center">Estos cambios son irreversibles.</p>
                <template #modal-footer>
                    <b-button variant="secondary" @click="cerrarModalBaja">Cancelar</b-button>
                    <b-button variant="danger" @click="confirmarBaja">Confirmar</b-button>
                </template>
                </b-modal>
                <!-- FIN Modal BAJA -->
            </template>
                <b-row> 
                    <b-col cols="9">
                        <div>
                            <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
                        </div>
                    </b-col> 
                <b-col cols="12" sm="5" md="5" lg="4" xl=3>
                    <b-pagination
                        :total-rows="total"
                        v-model="currentPage"
                        @input="listarRetenciones"
                        :per-page="limite"
                        align="center"
                    ></b-pagination>
                </b-col>
            </b-row>
            <b-modal
                id="prevmodal"
                size="lg"
                title="Vista Previa"
                cancel-title="Cerrar"
                v-model="previewmodalRetencion">
                <template v-if="cargandopdf2">
                    <div class="text-center">
                        <h3>
                        <i class="fa fa-spin fa-spinner"></i>
                        </h3>Cargando vista previa
                    </div>
                </template>
                <template v-else>
                    <template v-if="pdfobject !==''">
                        <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
                    </template>
                </template>
            </b-modal>
        </b-card>
    </div>
</template>
<script>
import axios from 'axios'

export default {
    name:'RetencionConsulta',
    data:()=> {
        return {
            retenciones:[],
            retenciones_fields:[
                {key:'serie',label:'Serie'},
                {key:'numero',label:'Numero'},
                {key:'fechaEmision',label:'Emisión'},
                // {key:'tasaRetencion',label:'Tasa Retención'},
                // {key:'observaciones',label:'Observaciones'},
                {key:'importeTotalRetenido',label:'Total Retenido'},
                {key:'importeTotalPagado',label:'Total Pagado'},
                {key:'estado',label:'Estado'},
                {key:'acciones',label:'Acciones'}          
            ],
            outlined:true,
            previewmodalRetencion: false,
            pdfobject:'',
            cargandopdf2: false,
            orden: "desc",
            limite: 15,
            currentPage: 1,   
            total: 0.00,
            desde: 0.00,
            hasta: 0.00, 
            cargando:false,
            mostrarModal: false, // Controla la visibilidad del modal BAJA
            dataSeleccionada: null, // Almacena los datos de la BAJA
            retencion:{
                token: '',
                fechaEmisionDocs: '',
                items: []
            }
        }
    },
    mounted(){
        this.listarRetenciones();
    },
    methods:{
       listarRetenciones(){
           this.cargando = true;
           axios
           .post(process.env.VUE_APP_API_URL + 'retencion/listar',{
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
           })
           .then(response=>(
               this.retenciones = response.data.data,
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to,
                this.cargando = false       
           ))
           .catch(error=>(
               console.log(response.data.msg)
           ))
       },
       viewPdfRetencion: function(data) {
            (this.previewmodalRetencion = true),
            (this.pdfobject = ""),
            (this.cargandopdf2 = true);
        axios
        .post(process.env.VUE_APP_API_URL + "retencion/pdf", {
            token: this.$store.getters.userToken,
            id: data.idRetencion
        })
        .then(response => (
            (this.pdfobject = response.data.base64),
            (this.cargandopdf2 = false)
        ))
        .catch(error => {});
        },
        abrirModalBaja(item) {
            this.dataSeleccionada = item; // Guarda los datos de la fila seleccionada
            this.mostrarModal = true; // Muestra el modal
        },
        cerrarModalBaja() {
            this.mostrarModal = false; // Cierra el modal
            this.dataSeleccionada = null; // Limpia los datos seleccionados
        },
        confirmarBaja() {
            let items = {
                descripcion: "Solicitud de baja",
                serie: this.dataSeleccionada.serie,
                numero:this.dataSeleccionada.numero,
                tipoComprobante:"20", //Tipo de comprobante ( "20" = retención, "40" = percepción )
            }

            let rete =[];
            rete.push(items);
            this.retencion.token = this.$store.getters.userToken;
            this.retencion.fechaEmisionDocs = this.$moment(this.dataSeleccionada.fechaEmision).format('YYYY-MM-DD');
            this.retencion.items = rete;

        
            axios
            .post(process.env.VUE_APP_API_URL + "resumenreversion/emitir", this.retencion)
            .then(response => {
                this.$bvToast.toast("Solicitud de baja enviada correctamente", {
                    title: "Éxito",
                    variant: "success",
                    solid: true
                });
                this.listarRetenciones();
            })
            .catch(error => {
                this.$bvToast.toast("Error al enviar la solicitud de baja", {
                    title: "Error",
                    variant: "danger",
                    solid: true
                });
            });
            this.cerrarModalBaja();
        }
    }
}
</script>
<style lang="stylus" scoped>

</style>